import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ITrackingAction } from 'i2g-ng-tracking';
import { DateTimeService } from 'i2g-ng-utils';
import { Observable, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { IconSizesEnum, IIcon } from '../../../icon/icon.component';
import { IFormFieldErrorMessages } from '../../form-master.interface';
import { FormFieldComponent } from '../form-field/form-field.component';

@Component({
  selector: 'i2g-date-picker-field',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePickerComponent
  extends FormFieldComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() placeholder = '';
  @Input() fieldId: string;
  @Input() fieldControl: AbstractControl;
  @Input() format = 'YYYY-MM-DD';
  @Input() maxDate: Date;
  @Input() layoutDirection: 'row' | 'column' = 'row';
  @Input() errorMessages: IFormFieldErrorMessages;
  @Input() focusableTrigger$: Observable<void>;

  caretIcon: IIcon = {
    name: 'chevron-down',
    size: IconSizesEnum.medium,
  };
  inputClass = '';

  private _fieldSub: Subscription;

  @ViewChild('dateInput') dateInput: ElementRef<HTMLInputElement>;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService,
    private _dateTimeService: DateTimeService
  ) {
    super(changeDetectorRef, translateService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.fieldControl &&
      // || changes.trackingObject
      // || changes.trackingScreenName
      this.fieldControl
      // && this.trackingObject
      // && this.trackingScreenName
    ) {
      if (this._fieldSub) {
        this._fieldSub.unsubscribe();
      }

      this._fieldSub = this.fieldControl.statusChanges
        .pipe(
          takeUntil(this.destroyed),
          filter(() => this.fieldControl.invalid)
        )
        .subscribe(() => {
          // const errors = this.fieldControl.errors;
          // let errorTrackingAction: ITrackingAction;
          // if (errors.required) {
          //   errorTrackingAction = this._trackingActionBuilder.buildErrorInvoked(
          //     'field_not_populated',
          //     this.fieldId,
          //     this.trackingScreenName
          //   );
          // } else if (errors.maxlength) {
          //   errorTrackingAction = this._trackingActionBuilder.buildErrorInvoked(
          //     'field_length_exceeded',
          //     this.fieldId,
          //     this.trackingScreenName
          //   );
          // }
          // if (errorTrackingAction) {
          //   this._trackingService.trackEvent(
          //     this.trackingObject,
          //     errorTrackingAction
          //   );
          // }
        });
    }
  }

  formatAndStoreDate(event: any) {
    this.fieldControl.setValue(
      this._dateTimeService.formatDate(event.value, this.format)
    );

    this.fieldControl.markAsDirty();
  }

  onDatePickerOpen() {
    this.inputClass = 'focus';
  }

  onDatePickerClose() {
    this.inputClass = '';

    // also blur the input
    this.dateInput.nativeElement.blur();
  }

  ngOnDestroy() {
    if (this._fieldSub) {
      this._fieldSub.unsubscribe();
    }

    super.ngOnDestroy();
  }
}
